<template>
    <div class="accessControl">
        <div class="head">
            <div class="head-title">{{$t('accessControl.accessControlList')}}</div>
            <div class="head-right">
                <div class="example-block">
                    <span class="example-demonstration">{{$t('accessControl.floor')}}：</span>
                    <el-cascader v-model="floor" :options="buildingAndFloor" @change="floorChange" />
                </div>
                <div class="addLadderControl" @click="add"><span>{{$t('accessControl.accessControlAdd')}}</span></div>
            </div>
        </div>
        <div class="accessControl-box">
            <noData v-if="doorList.length <= 0"></noData>
            <div v-else class="accessControlCard" v-for="(item, index) in doorList" :key="item.id">
                <div class="accessControlCard-left">
                    <img src="../../assets/images/public/accessControl-pic.png">
                </div>
                <div class="accessControlCard-right">
                    <h6>{{ item.nick_name }}</h6>
                    <p>{{$t('accessControl.floor')}}：<span>{{ item.floor_name ? item.floor_name : '-' }}</span></p>
                </div>
                <div class="edit-delete">
                    <img src="../../assets/images/public/edit.png" @click="ladderControlDeit(item, index)">
                    <img src="../../assets/images/public/delete.png" @click="ladderControlDelete(item, index)">
                </div>
            </div>
        </div>
        <paging v-if="total > 12" :totalCompone="total" @changePage="changePage"></paging>
        <el-dialog v-model="dialogAccessControl" :title="dialogTitle" width="30%" :close-on-click-modal="false"
            destroy-on-close :before-close="handleClose" @close="dialogclose">
            <el-form :model="form" :rules="rules" label-width="120px">
                <div class="select-box">
                    <el-form-item :label="$t('accessControl.accessControlID')+':'" prop="selectRules">
                        <el-cascader v-model="value" :options="optionsA" :disabled="cascaderDisabled"
                            :placeholder="$t('accessControl.selectAccessControlID')" @change="handleChange(value)" />
                        <!-- 提示 -->
                        <el-popover placement="top-start" :width="360" trigger="hover"
                            :content="$t('accessControl.accessControlID-Hint')">
                            <template #reference>
                                <Warning class="warning" />
                            </template>
                        </el-popover>
                    </el-form-item>
                </div>
                <div class="select-box">
                    <el-form-item :label="$t('accessControl.label')+':'" prop="name">
                        <el-input v-model="form.name" :placeholder="$t('accessControl.pleaseLabel')" maxlength="20" autocomplete="off" />
                    </el-form-item>
                </div>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogAccessControl = false">{{$t('robot.cancel')}}</el-button>
                    <el-button type="primary" :disabled="value && form.name ? false : true" @click="confirm">{{$t('robot.confirm')}}
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 删除确认弹窗 -->
        <dialogs :dialogVisibles="deleteOpen" :msg="$t('robot.deleteAccessControl-Hint')" :title="$t('robot.deleteAccessControl')" @off="OFF" @on="ON"
            :buttonColor="'#F5222D'" name="footer"></dialogs>
    </div>
</template>

<script lang="ts">
import { doorQuery, deviceListQuery, doorAdd, doorPut, doorDelete } from "@/apis/accessControl";
import { buildingAll } from '@/apis/building'
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import dialogs from '@/components/dialogs/dialogs.vue'
import paging from '@/components/paging/paging.vue'
import noData from '@/components/noData/noData.vue'
import { ElMessage } from "element-plus";
import i18n from "@/locales/index";
const _t = i18n.global.t;

export default defineComponent({
    components: {
        dialogs,
        paging,
        noData
    },
    setup() {
        const state = reactive({
            centerDialogVisible: false,
            value: '',
            total: 0,
            deleteOpen: false,
            dialogAccessControl: false,
            LadderControlData: '' as any,
            LadderControlIndex: '' as any,
            dialogTitle: _t('accessControl.accessControlAdd'),
            cascaderDisabled: false,
            flag: '', // 添加&编辑标识
            floor: '',
            form: {
                region: '',
                name: ''
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }],
                name: [{ required: true, message: _t('accessControl.pleaseLabel'), trigger: 'blur', }]
            } as any,
            optionsA: [
                {
                    value: 'wanglong',
                    label: '旺龙',
                    children: [

                    ],
                },
            ],
            buildingAndFloor: [

            ] as any,
            doorList: [

            ] as any,
            options: [

            ],
            params: {
                floor_id: '',
                pageSize: 12,
                page: 1,
                limit: true
            },
            // 页码切换
            changePage(val: number) {
                state.params.page = val
                state.query()
            },
            OFF() {
                state.deleteOpen = false
            },
            ON() {
                let params = {
                    id: state.LadderControlData.id
                }

                doorDelete(params).then((res: any) => {
                    console.log('删除结果', res)
                    if (res.code == 200) {
                        state.doorList.splice(state.LadderControlIndex, 1)
                    }
                    state.deleteOpen = false
                })
            },
            // 删除
            ladderControlDelete(cardData: object, index: number) {
                state.LadderControlData = cardData
                state.LadderControlIndex = index
                state.deleteOpen = true
            },
            // 编辑
            ladderControlDeit(cardData: any, index: number) {
                console.log('cardData', cardData)   
                state.LadderControlData = cardData
                state.LadderControlIndex = index
                state.flag = 'edit'
                state.dialogAccessControl = true
                state.dialogTitle = _t('accessControl.editAccessControl')
                state.cascaderDisabled = true
                state.value = cardData.door_id
                state.form.name = cardData.nick_name // 备注名
            },
            checkChange() {
                console.log('111')
            },
            selcetChange(val: any) {
                console.log('选中的指', val)
                state.query(state.floor[1])
            },
            // dislog关闭回调
            dialogclose() {
                state.value = ''
                state.form.name = ''
                state.dialogTitle = ''
            },
            handleClose() {
                state.dialogAccessControl = false
            },
            floorChange() {
                console.log('搜索选中的值', state.floor)
                state.query(state.floor.length >= 2 ? state.floor[1] : state.floor[0])
            },
            handleChange(val: any) {
                console.log(state.value)
            },
            // 添加 || 删除
            confirm() {
                if (state.flag == 'add') {
                    let params = {
                        door_id: state.value[1],
                        nick_name: state.form.name
                    }
                    doorAdd(params).then((res: any) => {
                        console.log('添加结果', res)
                        if (res.code == '200') {
                            state.dialogAccessControl = false
                            state.query()
                        }
                        if (res.code == '60001') {
                            ElMessage.error(_t('accessControl.accessControlIdExists'))
                        }
                    })
                } else {
                    let params = {
                        door_id: state.LadderControlData.door_id,
                        nick_name: state.form.name
                    }
                    doorPut(params, state.LadderControlData.id).then((res: any) => {
                        console.log('编辑结果', res)
                        if (res.code == 200) {
                            state.dialogAccessControl = false
                            state.query()
                        }
                    })
                }

            },
            add() {
                state.flag = 'add'
                state.dialogTitle = _t('accessControl.accessControlAdd')
                state.dialogAccessControl = true
                state.cascaderDisabled = false
            },
            query(floor_id: string = '-1') {

                state.params.floor_id = floor_id
                console.log(state.params)
                doorQuery(state.params).then((res: any) => {
                    console.log('门禁查询', res)
                    state.total = res.data.total
                    state.doorList = res.data.list
                })
            },
            init() {
                state.query()
                // 门禁设备查询
                deviceListQuery({ sn: 'b0416f03d030' }).then((res: any) => {
                    console.log('设备数据', res)
                    res.data.map((item: any) => {
                        item.value = item.deviceUnique
                        item.label = item.deviceUnique
                    });
                    state.optionsA[0].children = res.data
                })
                buildingAll('').then((res: any) => {
                    console.log('全部楼宇楼层', res)
                    res.data.forEach((item: any) => {
                        item.label = item.name
                        item.value = item.ID
                        if (item.floor_list) {
                            item.floor_list.forEach((el: any) => {
                                el.label = el.name
                                el.value = el.ID
                            })
                        }
                        item.children = item.floor_list
                    });
                    state.buildingAndFloor = res.data
                    state.buildingAndFloor.unshift({ value: 0, label: _t('public.notAssociatedFloor') })
                    state.buildingAndFloor.unshift({ value: -1, label: _t('public.all') })
                    state.floor = state.buildingAndFloor[0].value // 默认选中全部
                    console.log('state.floor', state.floor)
                })
            }
        })

        onMounted(() => {
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
</script>

<style lang="scss">
.accessControl {
    .head-right {
        .el-input__inner {
            width: 300px;
        }
    }

    .el-dialog__header,
    .el-dialog__footer {
        position: relative;
    }

    .el-dialog__header::before {
        content: " ";
        position: absolute;
        left: 0;
        bottom: 0px;
        width: 100%;
        height: 1px;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        transform-origin: 0 0;
    }

    .el-dialog__footer::before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        border-top: 1px solid rgba(0, 0, 0, 0.05);
        transform-origin: 0 0;
    }

    .select-box {
        display: flex;
        justify-content: center;
        margin-right: 53px;
        cursor: pointer;

        .el-form-item {
            position: relative;
            width: 460px;
        }

        .el-cascader {
            width: 310px;
        }

        .tips {
            p {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                line-height: 20px;
            }
        }

        .warning {
            position: absolute;
            top: 9px;
            right: -25px;
            width: 18px;
            height: 18px;
        }
    }

}
</style>

<style lang="scss" scoped>
h6,
p {
    padding: 0;
    margin: 0;
}

.accessControl {
    width: 97.5%;
    min-height: 750px;
    padding: 20px 0 20px 20px;
    margin: 20px;
    background: #FFFFFF;

    .head {
        margin-bottom: 40px;

        .head-title {
            float: left;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        .head-right {
            float: right;
            display: flex;
            align-items: center;
            margin-right: 20px;

            .addLadderControl {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 40px;
                width: 102px;
                height: 32px;
                background: #1890FF;
                border-radius: 2px;
                cursor: pointer;

                span {
                    height: 20px;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 20px;
                }
            }
        }
    }
}

.accessControl-box {
    cursor: pointer;
    width: 100%;
    height: 695px;
    background: #FFFFFF;
}

.accessControlCard:hover {
    border: 2px solid #1890FF;

    .edit-delete {
        display: flex;
    }
}

.accessControlCard {
    position: relative;
    margin: 20px 23px 0 2px;
    display: inline-block;
    width: 337px;
    height: 200px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;

    .edit-delete {
        display: flex;
        position: absolute;
        top: 10px;
        right: 15px;
        display: none;

        img:nth-child(1) {
            margin-right: 20px;
        }
    }

    .accessControlCard-left {
        position: relative;
        display: inline-block;
    }

    .accessControlCard-right {
        display: inline-block;
        position: relative;
        top: -73px;
        left: 20px;

        h6 {
            width: 170px;
            margin-bottom: 30px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        p {
            height: 18px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 18px;
            margin-bottom: 5px;

            img {
                position: relative;
                top: 3px;
                margin-left: 10px;
            }
        }
    }
}

.from-box {
    width: 500px;
    height: 277px;
    border: 1px solid #D9D9D9;
    border-radius: 2px;

    .from-box-title {
        display: flex;
        align-items: center;
        height: 40px;
        background: #FAFAFA;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .buildingName {
            margin-left: 30px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 20px;
        }

        .ladderId {
            margin-left: 60px;
        }
    }

    .from-box-tl {
        display: flex;
        align-items: center;
        height: 40px;
        background: #FFFFFF;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .name {
            margin-left: 30px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
        }

        .checkID {
            margin-left: 139px;
        }

        .el-select {
            height: 36px;
        }
    }
}
</style>